function initCustomFooter() {
  document.querySelectorAll('.custom-footer__menus').forEach((menus) => {
    if (menus.dataset.footerAccordionBound) return;
    menus.dataset.footerAccordionBound = 'true';

    menus.addEventListener('toggle', (event) => {
      if (event.target.tagName !== 'DETAILS' || !event.target.open) return;
      menus.querySelectorAll('.custom-footer-menu__details[open]').forEach((details) => {
        if (details !== event.target) details.open = false;
      });
    }, true);
  });
}

initCustomFooter();
document.addEventListener('shopify:section:load', initCustomFooter);
